import http from "@/shared/services/http";
import {RoleParams} from "@/modules/roles/params";

export const listFunctionPermission = () => http.get(`v1/roles/list-function-permissions`);
export const listRole = (params: RoleParams) => http.get(`v1/roles`, { params });
export const singleRole = (id: number) => http.get(`v1/roles/${id}`);
export const updateRole = (id: number, data: any) => http.put(`v1/roles/${id}`, data);
export const deleteRole = (id: number) => http.delete(`v1/roles/${id}`);
export const createRole = (data: any) => http.post(`v1/roles`, data);
export const listAccountOfRole = (roleId, params: any) => http.get(`v1/roles/list-accounts/${roleId}`, { params });
export const accountJoinRole = (data: any) => http.post(`v1/roles/join-role`, data);
export const accountOutRole = (data: any) => http.post(`v1/roles/out-role`, data);